





























import { ButtonType, Status } from './defaultConfigs';
import Spinner from '@/uikit/components/AppButtonNew/spinner.vue';
import AppSvgIcon from '@/uikit/components/AppSvgIcon/AppSvgIcon.vue';

export default {
  name: 'AppButtonNew',
  components: { Spinner, AppSvgIcon },
  props: {
    type: ButtonType,
    link: Boolean,
    iconTemplate: {
      default: undefined,
    },
    color: String,
    colorHover: String,
    width: String,
    callBackFn: {},
    iconColor: String,
    iconClass: String,
    defaultStatus: Status,
    component: String,
    target: String,
    iconColorMode: {
      type: String,
      default: 'none',
      validator: (val: any) =>
        ['none', 'fill', 'stroke', 'multi'].includes(val),
    },
    iconSize: {
      type: String,
      default: 'medium',
      validator: (val: any) => ['small', 'medium', 'large'].includes(val),
    },
    /** ширина вручную, если указано игнорирует size ширину */
    iconManualWidth: {
      type: String,
      default: null,
    },
    /** высота вручную, если указано игнорирует size высоту */
    iconManualHeight: {
      type: String,
      default: null,
    },
    iconText: {
      type: String,
    },
    to: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    title: String,
  },
  data() {
    return {
      status: this.defaultStatus || 'ready',
      hasError: false,
    };
  },
  computed: {
    getStyle() {
      let ret: any = {};
      if (this.width) {
        ret['--ui_button_width'] = this.width;
      }
      if (this.color) {
        ret['--ui-app-button-color'] = this.color;
      }
      if (this.colorHover) {
        ret['--ui-app-button-hover-color'] = this.colorHover;
      } else if (this.color) {
        ret['--ui-app-button-hover-color'] = this.color;
      }
      return ret;
    },
    getClasses() {
      let ret = [];
      ret.push(this.type);
      if (this.isDisabled) {
        ret.push('disabled');
      }
      if (this.iconTemplate && this.iconText) {
        ret.push('icon_with_text');
      }
      return ret;
    },
    getHref() {
      if (this.component === 'router-link') {
        return this.to;
      } else if (this.to) {
        if (typeof this.to === typeof {}) {
          return this.$router.resolve(this.to).href;
        } else {
          return this.to;
        }
      }
      return undefined;
    },
    getComponent() {
      if (this.component) {
        return this.component;
      }
      return this.to ? 'a' : 'button';
    },
    isDisabled() {
      return this.disabled || this.status === Status.loading;
    },
  },
  methods: {
    async click($event: any) {
      this.$emit('click', $event);
      if (this.callBackFn) {
        console.log(this.callBackFn);
        this.setStatus(Status.loading);
        try {
          await this.callBackFn();
          this.hasError = false;
        } catch (e) {
          this.hasError = true;
          this.$emit('error', e);
        } finally {
          this.setStatus(Status.loaded);
        }
      }
    },
    setStatus(status: Status) {
      this.status = status;
      this.$emit('statusChanged', status);
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppButtonNew/AppButtonNew.vue